import React, { useState, useCallback, memo } from "react";
import Slider from "react-slick";
import birthdayImg from "../../../../assets/BirthdayCake.svg";
import anniversaryImg from "../../../../assets/Flower_Bouquet_Final.svg";
import ImageModalComponent from "../ImageModalComponent/ImageModalComponent";

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  vertical: true,
  verticalSwiping: false,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
};

const BirthdayCards = memo(({ birthday, onImageClick }) => {
  return (
    <Slider {...sliderSettings}>
      {birthday && birthday.length > 0 ? (
        birthday.map((card) => {
          const nameParts = (card.name || "").trim().split(/\s+/);
          const displayName =
            nameParts.length > 0
              ? `${nameParts[0]}${
                  nameParts.length > 1
                    ? ` ${nameParts[nameParts.length - 1]}`
                    : ""
                }`
              : "";

          return (
            <div key={card.id} className="cele-card">
              <div
                className="profile-img-container"
                onClick={() => onImageClick(card.image)}
                style={{ cursor: card.image ? "pointer" : "default" }}
              >
                <img
                  src={card.image || ""}
                  alt={card.name}
                  className="profile-img"
                />
              </div>
              <div className="person-name">
                <b>{displayName}</b>
              </div>
            </div>
          );
        })
      ) : (
        <div className="cele-card">
          <div className="profile-img-container-b">
            <img src={birthdayImg} alt="Demo" className="profile-img-b" />
          </div>
          <div className="person-name">
            <b></b>
          </div>
        </div>
      )}
    </Slider>
  );
});

const AnniversaryCards = memo(({ anniversaries, onImageClick }) => {
  return (
    <Slider {...sliderSettings}>
      {anniversaries && anniversaries.length > 0 ? (
        anniversaries.map((card) => (
          <div key={card.id} className="cele-card">
            <div
              className="profile-img-container"
              onClick={() => onImageClick(card.image)}
              style={{ cursor: card.image ? "pointer" : "default" }}
            >
              <img src={card.image} alt={card.name} className="profile-img" />
            </div>
            <div className="person-name">
              <b>{card.name}</b>
            </div>
          </div>
        ))
      ) : (
          <div className="cele-card">
          <div className="profile-img-container-e">
            <img src={anniversaryImg} alt="Demo" className="profile-img-e" />
          </div>
          <div className="person-name">
            <b></b>
          </div>
        </div>
      )}
    </Slider>
  );
});

const CelebrationSection = ({ birthday = [], anniversaries = [] }) => {
  const [celeOpen, setCeleOpen] = useState(true);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const toggleCeleOpen = useCallback(() => {
    setCeleOpen((prev) => !prev);
  }, []);

  const handleImageClick = useCallback((imageUrl) => {
    if (imageUrl) {
      setSelectedImage(imageUrl);
      setIsImageModalOpen(true);
    }
  }, []);

  const closeImageModal = useCallback(() => {
    setIsImageModalOpen(false);
    setSelectedImage("");
  }, []);

  return (
    <div className="row mt-2">
      <div className="col-md-12 dashKPI">
        <div className="custom-accordion">
          <div className="custom-header" onClick={toggleCeleOpen}>
            <div className="d-flex justify-content-between">
              <div className="leader_Board-card">
                <h5>Celebrating Today</h5>
              </div>
            </div>
            <span className={`arrow-icon ${celeOpen ? "open" : ""}`}>
              <i className="bi bi-arrow-down-circle-fill"></i>
            </span>
          </div>
          {celeOpen && (
            <div className="celebrate-custom-body">
              <div className="container celebration-container">
                <div className="row card-container">
                  <div className="col-6 birthday-section p-2">
                    <div className="celebration-title birthday-title">
                      {/* Birthdays */}
                    </div>
                    <BirthdayCards
                      birthday={birthday}
                      onImageClick={handleImageClick}
                    />
                  </div>

                  <div className="col-6 position-relative anniversary-section">
                    <div className="divider"></div>
                    <div className="celebration-title anniversary-title mt-2">
                      {/* Anniversaries */}
                    </div>
                    <AnniversaryCards
                      anniversaries={anniversaries}
                      onImageClick={handleImageClick}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <ImageModalComponent
        isOpen={isImageModalOpen}
        imageUrl={selectedImage}
        onClose={closeImageModal}
      />
    </div>
  );
};

export default memo(CelebrationSection);
